<div class="initiate-form feedback-form h-100">

    <div class="prediction-data-form">
        <div class="left">
            <div class="run-selector">
                <div class="section-title">Select prediction by run date...</div>
                <div class="selection-block prediction-date-container">
                    <app-prediction-selector 
                      [runs]="runsData()"
                      [isLoading]="isPredictionLoading"
                      [isDisabled]="isFieldDisabled()"
                      [placeholder]="'Select a prediction'"
                      (selectionChange)="onRunSelected($event)">
                    </app-prediction-selector>
                </div>
            </div>
           
            <div class="run-selector">
                <div class="section-title">Or set manually the prediction values</div>

                <div class="date-picker-container control-container">
                    <!-- <label>Run date</label> -->
                                        <p-datepicker 
                      appendTo="body"
                      [(ngModel)]="runDate" 
                      [showIcon]="true" 
                      [showOnFocus]="false" 
                      inputId="buttondisplay"
                      placeholder="Select run date" 
                      [disabled]="isFieldDisabled()"
                      (onSelect)="onRunDateChange($event)"/>
                </div>
            </div>

            
        </div>
        <div class="divider"> <p-divider layout="vertical"></p-divider></div>
        <div class="right">
            
            <div class="selection-block followed-scenario control-container" >
                <label>Scenario</label>
                <p-select 
                *ngIf="!isPredictionLoading"
                [options]="followedScenarioDropdown()" 
                [(ngModel)]="selectedFollowedScenario" 
                optionLabel="description" 
                [disabled]="isScenarioFieldDisabled"
                (onChange)="onFollowedScenarioChange($event)"></p-select>
                <div class="loading-block" *ngIf="isPredictionLoading"><fa-icon  [icon]="faSpinner" class="spinner-icon fa-spin-pulse"></fa-icon></div>
            </div>

            <div class="scenario-name-input control-container input-field" *ngIf="!isScenarioNameDisabled">
                <div class="label-and-input">
                    <label>Scenario name</label>
                    <div class="input-container">
                        <input 
                        type="text" 
                        id="scenario_name" 
                        [ngClass]="{ 'invalid-input': scenarioNameNotValid() }"
                        [(ngModel)]="scenarioName" 
                        (input)="onScenarioNameChange($event)"
                        maxlength="100" />
                    </div>
                </div>
                <small [ngClass]="{ 'visible': scenarioNameNotValid() }">Scenario name is required</small>
            </div>

            <div class="predicted-price-input control-container input-field">
                <div class="label-and-input">
                    <label>Ensemble</label>
                    <div class="input-container">
                        <span>$</span><input 
                        [disabled]="isPredictedPriceDisabled" 
                        [ngClass]="{ 'invalid-input': predictedPriceNotValid() }" 
                        type="number" 
                        id="manual-predicted-price" 
                        [(ngModel)]="predictedPrice" 
                        (input)=" validatePredictedPrice($event)" 
                        (focusout)="storePredictedPriceValue($event)" 
                        maxlength="12" size="3" />
                    </div>
                </div>
               
                <small [ngClass]="{ 'visible': predictedPriceNotValid() }">Must be a valid numeric value</small>
            </div>
        </div>
    </div>
    
    <div class="trade-data-form">

        <div class="trade-data">
            <div class="date-picker-container control-container">
                <label>Trade date</label>
                                <p-datepicker 
                  appendTo="body"
                  [disabled]="isFieldDisabled()"
                  [(ngModel)]="tradeDate" 
                  [showIcon]="true" 
                  [showOnFocus]="false" 
                  inputId="buttondisplay"
                  placeholder="Select trade date" 
                  (onSelect)="onTradeDateChange($event)"/>
            </div>
            <div class="selection-block followed-scenario">
                <label>Contract</label>
                <div class="contract-dropdown-container">
                    <p-select [options]="monthsDropdown()" 
                    [disabled]="isFieldDisabled()"
                    [(ngModel)]="selectedMonth" 
                    optionLabel="description" 
                    (onChange)="onMonthDropdownChange($event)"></p-select>

                    <p-select [options]="yearsDropdown()" 
                    [disabled]="isFieldDisabled()"
                    [(ngModel)]="selectedYear" 
                    optionLabel="description" 
                    (onChange)="onYearDropdownChange($event)"></p-select>
                </div>
             
            </div>
            <div class="selection-block radiobuttons-container">
                <div class="field-radiobutton">
                    <p-radioButton name="option" value="short"   [disabled]="isFieldDisabled()" [(ngModel)]="selectedDirection" inputId="short" (ngModelChange)="onDirectionChange()"/>
                    <label for="short">Short</label>
                  </div>
                  
                  <div class="field-radiobutton">
                    <p-radioButton name="option" value="long"   [disabled]="isFieldDisabled()" [(ngModel)]="selectedDirection" inputId="long" (ngModelChange)="onDirectionChange()"/>
                    <label for="long">Long</label>
                  </div>
                  
            </div>
            <div class="trade-price-input input-field">
                <div class="label-and-input">
                    <label>Trade price</label>
                    <div class="input-container"><span>$</span><input 
                        [ngClass]="{ 'invalid-input': tradePriceNotValid() }"
                        [disabled]="isFieldDisabled()"
                        type="number" id="manual-predicted-price" 
                        [(ngModel)]="tradePrice" 
                        (input)=" validateTradePrice($event)" 
                        (focusout)="storeTradePriceValue($event)"   maxlength="12" size="3" /></div>
                </div>

                <small [ngClass]="{ 'visible': tradePriceNotValid() }">Must be a valid numeric value</small>
                
            </div>
            <div class="lots-input input-field">
                <div class="label-and-input">
                    <label>Lots/contracts </label>
                    <div class="input-container"><input type="number" step="1"
                        [ngClass]="{ 'invalid-input': lotsInputNotValid() }"
                        [disabled]="isFieldDisabled()"
                        id="manual-predicted-price" [(ngModel)]="lots" (keydown)="preventDecimalInput($event)" (input)=" validateLotsQty($event)" (focusout)="storeLotsQty($event)"   maxlength="12" size="3" /></div>
                  
                </div>
                  <small [ngClass]="{ 'visible': lotsInputNotValid() }">Must be a valid numeric value</small>
            </div>

        </div>

        <div class="free-text">
            <label>Additional commentary</label>
            <textarea pInputTextarea [(ngModel)]="freeText"
            [disabled]="isFieldDisabled()"
            (input)=" validateFreeText($event)"
             (blur)="onFreeTextEntered()"  rows="10" cols="30" placeholder="Enter your comments here..."></textarea>

        </div>

    </div>
</div>
